module.exports = __webpack_public_path__ + "static/img/1203_phase_function_Paper_PointsHejduk_Prediction.b221ca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1203_phase_function_Paper_PointsHejduk_Prediction.png
// module id = x/bp
// module chunks = 0